import React from 'react';
import { STEPS } from '../CheckoutModal';

const ConfirmAddressStep = ({ state, dispatch, storeData, storeSlug, formatPrice, goToStep, goBack }) => {
  // finalShippingCost is what the customer actually owes — it honors
  // the merchant's "free over ₦N" threshold. Fall back to raw
  // shippingCost when the backend hasn't set finalShippingCost yet
  // (e.g., default / degraded state).
  const rawShippingCost = state.shippingCalculation?.shippingCost || 0;
  const shippingCost = state.shippingCalculation?.finalShippingCost != null
    ? Number(state.shippingCalculation.finalShippingCost)
    : rawShippingCost;
  const isFreeShipping = shippingCost === 0
    || state.shippingCalculation?.isFreeShipping === true;
  const estimatedDays = state.shippingCalculation?.estimatedDeliveryDays || 3;
  const zoneName = state.shippingCalculation?.zoneName;

  const handleContinue = () => {
    goToStep(STEPS.DELIVERY_OPTIONS);
  };

  return (
    <div className="cm-step cm-confirm-address-step">
      <div className="cm-address-card">
        <div className="cm-address-card-header">
          <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
            <circle cx="12" cy="10" r="3" />
          </svg>
          <span>Delivery Address</span>
        </div>
        <div className="cm-address-card-body">
          <p className="cm-address-name">{state.fullName}</p>
          <p className="cm-address-line">{state.deliveryAddress}</p>
          {state.deliveryCity && (
            <p className="cm-address-line">{state.deliveryCity}</p>
          )}
          <p className="cm-address-line">{state.deliveryState}</p>
          {state.deliveryCountry && (
            <p className="cm-address-line">{state.deliveryCountry}</p>
          )}
        </div>
      </div>

      <div className="cm-shipping-info">
        <div className="cm-shipping-info-header">
          <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
            <rect x="1" y="3" width="15" height="13" />
            <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
            <circle cx="5.5" cy="18.5" r="2.5" />
            <circle cx="18.5" cy="18.5" r="2.5" />
          </svg>
          <span>Shipping Details</span>
        </div>

        <div className="cm-shipping-info-body">
          <div className="cm-shipping-row">
            <span className="cm-shipping-label">Shipping Cost</span>
            {isFreeShipping ? (
              <span className="cm-shipping-value cm-shipping-free">FREE</span>
            ) : (
              <span className="cm-shipping-value">{formatPrice(shippingCost)}</span>
            )}
          </div>

          <div className="cm-shipping-row">
            <span className="cm-shipping-label">Estimated Delivery</span>
            <span className="cm-shipping-value">{estimatedDays} business days</span>
          </div>

          {zoneName && (
            <div className="cm-shipping-row">
              <span className="cm-shipping-label">Zone</span>
              <span className="cm-shipping-value">{zoneName}</span>
            </div>
          )}
        </div>
      </div>

      <div className="cm-step-footer">
        <button type="button" className="cm-btn cm-btn-secondary" onClick={goBack}>
          <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
          Back
        </button>
        <button type="button" className="cm-btn cm-btn-primary" onClick={handleContinue}>
          Continue
          <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default ConfirmAddressStep;
